import { CubeTimeDimensionGranularity } from '../enum/cube-time-dimension-granularity.enum';

export const getGranularityNumericalOffset = (
  granularity: CubeTimeDimensionGranularity
): number => {
  switch (granularity) {
    case CubeTimeDimensionGranularity.Day:
      return 1;
    case CubeTimeDimensionGranularity.Week:
      return 7;
    default:
      return 31;
  }
};
